import { render, staticRenderFns } from "./RestaurantSales.vue?vue&type=template&id=ec18a386&"
import script from "./RestaurantSales.vue?vue&type=script&lang=js&"
export * from "./RestaurantSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports